/* eslint-disable import/prefer-default-export */
export const setDeletedState = (data) => ({
  type: 'SET_DELETED_STATE',
  payload: data,
});
